<template>
	<v-container fluid class="height-100">
		<v-row class="height-100">
			<v-col md="3" class="pl-0 pr-1 pt-0">
				<v-card class="py-4 px-6" elevation="0" style="min-height: calc(100vh - 106px); height: 100%">
					<v-card-title class="pl-0 pt-2">
						<v-sheet>
							<span class="title font-weight-bold">机构信息</span>
							<p class="caption grey--text mb-0">政务服务网获取服务机构信息</p>
						</v-sheet>
					</v-card-title>
					<v-list-item class="px-0 pb-2">
						<v-list-item-content>
							<v-list-item-title class="mb-3"
								><span class="title">{{ user.uniName }}</span></v-list-item-title
							>
							<v-list-item-subtitle>信用证号：{{ user.uniCode }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-divider class="my-3" />
					<v-card-title class="pl-0 pt-2 body-1">基本信息</v-card-title>
					<v-card-text class="pl-0 pb-1">
						<p>注册地区：{{ user.uniAreaName }}</p>
						<p>认证状态：{{ user.stateNote }}</p>
						<p>机构地址：{{ user.address }}</p>
						<p>机构介绍：{{ user.description }}</p>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col md="9" class="pt-0">
				<v-card elevation="0" style="min-height: calc(100vh - 106px); height: 100%">
					<v-card-title>
						<v-icon class="mr-2" color="blue">mdi-google-earth</v-icon>
						企业信息完善<v-spacer />
						<v-btn depressed @click="$router.go(-1)"><v-icon>mdi-chevron-left</v-icon> 返回</v-btn>
					</v-card-title>
					<v-card-text class="pt-6">
						<v-form ref="entity" v-model="valid" :model="entity">
							<vtk-form-item label="机构名称：" must left>
								<v-text-field placeholder="机构名称" v-model="entity.code" dense readonly outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="信用证号：" must left>
								<v-text-field placeholder="信用证号" :rules="[(v) => !!v || '信用证号不能为空!']" v-model="entity.name" readonly dense outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="机构电话：" must left>
								<v-text-field placeholder="机构电话" :rules="[(v) => !!v || '机构电话不能为空!']" v-model="entity.phone" readonly dense outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="开户银行：" must left>
								<v-text-field placeholder="开户银行" :rules="[(v) => !!v || '开户银行不能为空!']" v-model="entity.phone" readonly dense outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="银行卡号：" must left>
								<v-text-field placeholder="银行卡号" :rules="[(v) => !!v || '银行卡号不能为空!']" v-model="entity.phone" readonly dense outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="联系人：" must left>
								<v-text-field placeholder="联系人" :rules="[(v) => !!v || '联系人不能为空!']" v-model="entity.contact" dense outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="联系人电话：" must left>
								<v-text-field placeholder="联系人电话" :rules="[(v) => !!v || '联系人电话不能为空!']" v-model="entity.mobile" dense outlined></v-text-field>
							</vtk-form-item>
							<vtk-form-item label="机构地址：" must left>
								<v-textarea placeholder="机构地址" :rules="[(v) => !!v || '机构地址不能为空!']" v-model="entity.address" dense outlined></v-textarea>
							</vtk-form-item>
							<vtk-form-item label="经营范围：" must left>
								<v-textarea placeholder="经营范围" v-model="entity.description" dense outlined></v-textarea>
							</vtk-form-item>
							<vtk-form-item left>
								<v-btn elevation="0" color="primary"><v-icon small class="mr-1">mdi-checkbox-marked-circle-outline</v-icon>保存</v-btn>
							</vtk-form-item>
						</v-form>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Storage from "@/commons/storage";
// import Request from "@/commons/request";
export default {
	name: "DashServ",
	data() {
		return {
			user: {},
			valid: true,
			entity: {},
		};
	},
	mounted() {
		this.user = Storage.get("_wit_acis_users");
	},
	methods: {},
};
</script>

<style lang="scss" scoped></style>
